
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1.2em","height":"1.2em","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M4.4 3A1.4 1.4 0 003 4.4V6a1 1 0 01-2 0V4.4A3.4 3.4 0 014.4 1H6a1 1 0 010 2zM17 2a1 1 0 011-1h1.6A3.4 3.4 0 0123 4.4V6a1 1 0 11-2 0V4.4A1.4 1.4 0 0019.6 3H18a1 1 0 01-1-1M2 17a1 1 0 011 1v1.6A1.4 1.4 0 004.4 21H6a1 1 0 110 2H4.4A3.4 3.4 0 011 19.6V18a1 1 0 011-1m20 0a1 1 0 011 1v1.6a3.4 3.4 0 01-3.4 3.4H18a1 1 0 110-2h1.6a1.4 1.4 0 001.4-1.4V18a1 1 0 011-1m-4-9a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1m-3 1a1 1 0 10-2 0v6a1 1 0 102 0zm-5-1a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1M7 9a1 1 0 10-2 0v6a1 1 0 102 0z"}})])
          )
        }
      }
    